export const layoutClassNames = Object.freeze({
  pageContainer: 'logto_page-container',
  mainContent: 'logto_main-content',
  customContent: 'logto_custom-content',
  signature: 'logto_signature',
  brandingHeader: 'logto_branding-header',
  brandPanel: 'logto_brand-panel',
  columnHeader: 'logto_column-header',
  columnFooter: 'logto_column-footer',
});
